import * as yup from "yup";

const deleteSchema = (translate: Function) => yup.object().shape({
	efd001Descricao: yup.string().required(translate("Nome do plano comercial não confere")).oneOf([yup.ref("efd001DescricaoConfirmation")], translate("Nome do plano comercial não confere"))
});

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	efd001Descricao: yup.string().required(translate("Descrição é requerido")),
	efd001Duracao: yup.number().required(translate("Duração é requerido")),
	efd001Tipo:  yup.number().required(translate("Tipo é requerido")),
	efd001Ativo: yup.string().oneOf(["S", "N"], translate("Ativo é requerido")),
	eftbd002: yup.array().of(yup.object().shape({
		efd002Tipo: yup.number().required("Tipo é requerido"),
		efd002Valor: yup.number(),
		efd002BloqExcedido: yup.string().oneOf(["S", "N"], translate("Bloqueio excedido é requerido"))
	}))
		.required(translate("É necessario preencher ao menos um item"))
		.unique(translate("Tipos não podem ser repetidos"), (a: any) => a.efd002Tipo)
});

export { deleteSchema, addAndChangeSchema };
